import {
  IExhibitorOnboardingTranslations,
  IExhibitorSessions, IExhibitorInteractionsTranslations, IExhibitorSettingsTranslations, IExhibitorSidebar, IExhibitorsDashboardTranslations, IExhibitorProducsTranslations, IExhibitorProductInteractions, IExhibitorProfile,
} from '.';

const dashboard: IExhibitorsDashboardTranslations = {
  home: 'Home',
  product_interactions_description: 'Número de pedidos de informação sobre produtos e serviços:',
  information: 'Information',
  name: 'Exhibitor name:',
  edit: 'Edit',
  interactions: 'Interactions',
  nrOfInteractions: 'Nr of interactions:',
  seeAll: 'See all',
  download: 'Download',
  sessions: 'Sessions',
  upcoming_sessions: 'Upcoming sessions',
  see_all_sessions: 'See all sessions',
  applications: 'Applications',
  see_applications: 'See applications',
  choose_exhibitor: 'Escolha o expositor que deseja administrar',
  schedule_meetings: 'Scheduled meetings',
  check_scheduled_meetings: 'Check the meetings candidates already scheduled',
};

const sidebar: IExhibitorSidebar = {
  title: 'Exhibiting',
  home: 'Home',
  interactions: 'Visitors',
  exhibitor_interactions: 'Contactos',
  exhibitor_sessions: 'Exhibitor sessions',
  sessions: 'Sessions',
  settings: 'Form',
  products: 'Ofertas de trabajo',
  product_interactions: 'Solicitudes de empleo',
};

const settings: IExhibitorSettingsTranslations = {
  title: 'Exhibitor settings',
  basicInfo: 'Basic information',
  save: 'Save',
  additionalInfo: 'Additional information',
  formError: 'No information retrieved, form not available.',
};

const products: IExhibitorProducsTranslations = {
  title: 'Products',
  subtitle: 'Crear, editar y eliminar ofertas de trabajo',
  no_products: 'No products available',
  new_product: 'New product',
  create_new_product: 'Create a new product and service',
  edit_product: 'Edit product',
  delete_confirm: 'Are you sure you want to delete this product?',
  interactions_exist_cannot_delete: 'Already has interactions. Cannot be deleted.',
  search_placeholder: 'Digite o que pretende procurar na lista de produtos',
  inputs: { name: 'Name' },
};

const interactions: IExhibitorInteractionsTranslations = {
  title: 'Interactions',
  subtitle: 'Interactions',
  download: 'Download',
  noInteractions: 'This exhibitor has no interactions.',
  interaction: {
    editComment: 'Edit comment',
    saveComment: 'Save comment',
    checkIn: 'CheckIn',
  },
  search_placeholder: 'Type what you want to search for in the contact list',
};

const onboarding: IExhibitorOnboardingTranslations = {
  step_authentication: 'Authentication',
  step_basicInfo: 'Basic information',
  step_additionalInfo: 'Additional information',
  step_review: 'Review',
  step_done: 'Done!',
  convert_titles: {
    logo: 'Logo',
    profile_pic: 'Profile picture',
    embedded: 'Youtube video',
    meeting_room: 'Enable meeting room',
  },
  login: {
    title: 'Está prestes a registar o seu expositor',
    subtitle: 'Primeiro faça login ou registe-se',
    message: 'Para registar o seu expositor precisamos que inicie sessão ou se registe com uma conta Beamian.',
    exhibitor_manager_name: 'Introduza o nome do gestor de expositor',
    exhibitor_manager_email: 'Introduza o email do gestor de expositor',
  },
  basicInformation: {
    title: 'Tell us about your exhibitor',
    warning: 'The information you provide will be used for the creation of the booklet as well as to create a profile for visitors to see.',
    createExhibitor: 'Create exhibitor',
    exhibitor_name: 'Exhibitor name',
    exhibitor_name_placeholder: 'Insert the name of your exhibitor (company)',
    modal: {
      title: 'Warning',
      subtitle: 'If you wish to manage your exhibitor please login first.',
      skip: 'Skip',
      createAccount: 'Create account',
      login: 'Login',
    },
  },
  managedFields: {
    title: 'Additional information',
    crop_image: 'Cortar imagen',
    crop_again: 'Volver a cortar',
  },
  review: {
    title: 'Review information',
    name: 'Name',
  },
  completed: {
    title: 'Exhibitor created!',
    subtitle: 'Your exhibitor is ready. Thank you for your submission!',
    manage: 'Manage',
  },
  back: 'Back',
  next: 'Next',
  submit: 'Submit',
};

const sessions: IExhibitorSessions = {
  title: 'Sessions',
  subtitle: 'Create, edit and delete meetings',
  start_date: 'Starts at:',
  end_date: 'Ends at:',
  join_meeting: 'Join meeting',
  meeting_url: 'Meeting URL:',
  description: 'Description:',
  new_session: 'New session',
  edit_session: 'Edit session',
  register: 'Registar na sessão',
  invited_users: 'Convidados',
  inputs: {
    name: 'Name',
    name_placeholder: 'Enter session name',
    start_date: 'Start date',
    start_date_placeholder: 'Enter session start date',
    end_date: 'End date',
    end_date_placeholder: 'Enter session end date',
    color: 'Color',
    color_placeholder: 'Enter session color',
    description: 'Description',
    description_placeholder: 'Enter session description',
    entrance_capacity: 'Entrance capacity',
    entrance_capacity_placeholder: 'Enter entrance capacity',
    registration_capacity: 'Registration capacity',
    registration_capacity_placeholder: 'Enter registration capacity',
    external_link: 'Meeting URL',
    external_link_placeholder: 'Enter meeting URL',
    external_link_warning_message: 'Leave blank if you want beamian to create a meeting room for you',
    order: 'Order',
    order_placeholder: 'Enter session order',
    private_session: 'Sesión privada',
  },
  session_label: 'Session',
  select_session: 'Select session',
  no_private_sessions: 'There are no exhibitor sessions',
  private_session_warning: 'If the session is private, only invited visitors will see it. If it is a public session, it will be visible to all visitors.',
  enable_chat: 'Enable chat',
  embed_meeting: 'Embed meeting video',
  embed_meeting_detail: 'If you uncheck this option the meeting link will open in a new tab',
};

const productInteractions: IExhibitorProductInteractions = {
  title: 'Pedidos de informação sobre produtos ou serviços',
  subtitle: 'Ver solicitantes de empleo, enviar invitaciones a reuniones',
  product_name: 'Oferta de trabajo',
  interaction_name: 'Nombre del candidato',
  application: 'Application',
  invite_to_session: 'Invite to private session',
  send_invite: 'Send invite',
  user_already_registered: 'This user is already registered on this session',
  publish_warning: 'By publishing this form the information will be visible to visitors',
  invitation_sent: 'Invitation sent successfully',
  search_placeholder: 'Insert what you wish to search on the information requests list',
};

const profile: IExhibitorProfile = {
  exhibitor_information: 'Información de la empresa',
  products: 'Ofertas de trabajo',
};

export default {
  dashboard, settings, interactions, onboarding, sidebar, sessions, products, productInteractions, profile,
};
